import React from 'react';

const YearTabs = ({ availableYears, activeYear, onYearChange, resolutionsByYear }) => {
	if (availableYears.length === 0) {
		return null;
	}

	return (
		<div className='mb-6'>
			<div className='border-b border-gray-200'>
				<nav className='-mb-px flex space-x-8'>
					{availableYears.map((year) => (
						<button
							key={year}
							onClick={() => onYearChange(year)}
							className={`py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap ${
								activeYear === year
									? 'border-blue-500 text-blue-600'
									: 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
							}`}
						>
							{year}
							{resolutionsByYear[year]?.length > 0 && (
								<span className='ml-2 bg-gray-100 text-gray-900 py-0.5 px-2.5 rounded-full text-xs'>
									{resolutionsByYear[year].length}
								</span>
							)}
						</button>
					))}
				</nav>
			</div>
		</div>
	);
};

export default YearTabs;
